import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  SAVE_FEATURE_CHECK_REQUEST,
  SAVE_FEATURE_CHECK_ERROR,
  SAVE_FEATURE_CHECK_SUCCESS,
} from 'actionTypes'

export const execute = (values, token) => (dispatch) => {
  dispatch(saveFeatureCheckRequest())
  return new Api(token, dispatch)
    .post(API_URL.SAVE_FEATURE_CHECK, values)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(saveFeatureCheckSuccess(response.data))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(hideSpinner())
      dispatch(saveFeatureCheckError(error))
    })
}

export const saveFeatureCheckRequest = () => ({
  type: SAVE_FEATURE_CHECK_REQUEST,
})

export const saveFeatureCheckError = (error) => ({
  type: SAVE_FEATURE_CHECK_ERROR,
  payload: error,
})

export const saveFeatureCheckSuccess = (data) => ({
  type: SAVE_FEATURE_CHECK_SUCCESS,
  payload: data,
})
